import type { JSX } from 'react'
import Merchant from '../BrowseMerchant'

const HomePage = (): JSX.Element => {
  return <Merchant />
}

export default HomePage
